// Generated i18n file
export default {
  title: '도쿄 메트로 24시간권',
  notes: {
    item1:
      '동시에 여러 장 구매한 승차권은 이용 시작 전에 각자의 스마트폰으로 SNS 등을 통해 분배할 수 있습니다.',
    item2:
      '1대의 단말기에서 여러 장의 QR 코드를 사용하는 경우, 바우처를 가진 고객이 마지막으로 통과하도록 해주십시오.',
    description2:
      '※평소보다 개찰기 통과 절차에 시간이 더 걸려, 원하시는 열차 등에 탑승하지 못할 수 있으니 시간 여유를 가지고 이용해 주시기 바랍니다.',
    item3:
      '본 승차권을 사용하여 도쿄 메트로선 이외의 노선에 탑승할 수 없습니다.',
    item4: 'QR 코드 인쇄물이나 스크린샷은 이용할 수 없습니다.',
    description4:
      '※스마트폰 등 단말기의 분실이나 배터리 방전 등으로 본 승차권의 효력을 화면 표시로 확인할 수 없는 경우, 승차권을 소지하지 않은 것으로 간주되어 본 승차권의 유효 구간을 포함한 실제 이용 구간의 정규 운임을 지불하셔야 합니다. 역에서 전원 등을 제공할 수 없으니 양해 부탁드립니다.',
    item5:
      '승차권의 유효 기간 및 유효 기한이 지나면 이용할 수 없습니다. (이용 시작 버튼을 누른 후 당일 막차까지 자동 개찰기 등 이용이 없는 경우에도 이용할 수 없습니다.)',
    item6:
      '환불은 유효 기간 내이며 이용 시작 전에 한하여 구매 이력 페이지에서 1건(1회 결제)당 환불 수수료 220엔이 발생합니다.',
    item7: '유효한 승차권 화면 제시로 대체 수송 대상이 됩니다.',
    item8:
      'QR 승차권을 이용할 수 없는 등의 문의 사항은 「예약 번호」와 「성함」을 명시하여 구매처로 연락 주시기 바랍니다.',
    description8: 'QR 코드는 DENSO WAVE INC.의 등록 상표입니다.',
    title: '주의사항'
  },
  explain: {
    description1:
      '도쿄 메트로선 내 한정 승차권으로, 사용 시작부터 24시간 동안 전 9개 노선을 무제한 승하차할 수 있는 할인 승차권입니다.',
    description2:
      '도쿄 메트로선의 최소 운임 180엔 구간(1~6km)에서 승하차할 경우, 4회 이상 탑승하는 것만으로도 이득입니다!',
    title: '이용 안내',
    area: '사용 가능 구간',
    areaValue: '도쿄 메트로 전 노선',
    howToUse: '사용 방법',
    step1: {
      alt: 'QR 디지털 티켓 구매',
      description:
        '① QR 승차권은 스마트폰으로 사전에 QR 디지털 티켓을 구매하여, 자동 개찰기에 QR 코드를 인식시켜 이용할 수 있는 서비스입니다.'
    },
    step2: {
      alt: 'QR 코드 대응 개찰구에서 승하차',
      description: '② QR 코드에 대응하는 개찰구에서 승하차할 수 있습니다.',
      tip: '※QR 코드에 대응하지 않는 개찰구에서는 개찰구의 역무원에게 문의해 주십시오. 부재 시에는 개찰구의 인터폰으로 역무원을 호출해 주십시오.'
    },
    step3: {
      alt: '이용 시작 버튼 누르기',
      description:
        '③ 이용 전에 반드시 「이용 시작」 버튼을 눌러 입장 처리를 해주십시오. 「이용 시작」 버튼을 누른 시점부터 이용 기간이 시작되므로, 환불이 불가능합니다. 반드시 이용 직전에 눌러주십시오.'
    },
    validityDescription:
      '구매 후 90일 이내의 1일에 한하여, 이용 시작 버튼을 누른 당일의 최초 개찰 이용부터 24시간 동안 유효',
    validityNotice:
      '※이용 시작을 누른 당일 중에 이용이 없는 경우에는 무효가 됩니다.',
    validityTitle: '유효 기간 또는 유효 기한'
  },
  faq: {
    title: '자주 묻는 질문',
    faqList: [
      {
        answer: `스마트폰 하나로 캐시리스로 구매·이용할 수 있는 할인 티켓입니다.
스마트폰에 표시되는 QR 코드와 애니메이션이 티켓을 대신합니다.
다음의 권종을 판매하고 있습니다.
・Tokyo Subway 24/48/72-Hour Ticket(QR)
・도쿄 메트로 도영 지하철 공통 1일 승차권(QR)
・도쿄 메트로 24시간권(QR)
`,
        question: 'QR 기획 승차권이란?'
      },
      {
        answer: `전용 웹사이트에서 「Google」 또는 「Email」 계정으로 로그인 후, 디지털 티켓의 종류를 선택하고 신용카드로 결제해 주십시오.
※등록하는 성명은 반각 로마자로 입력해 주십시오.`,
        question: '구매 방법은?'
      },
      {
        answer: 'VISA, MasterCard, JCB, American Express, Diners',
        question: '카드 결제로 이용 가능한 신용카드는?'
      },
      {
        answer: `신용카드 회사에서 3D Secure가 필요합니다.
설정을 포함하여, 기타 신용카드 결제가 되지 않는 경우에도 신용카드 회사로 문의해 주십시오.`,
        question: '신용카드 결제를 사용할 수 없을 때는?'
      },
      {
        answer: `QR 기획 승차권은 스마트폰 등의 정보 단말기를 소지하지 않으면 이용할 수 없습니다. 또한 화면 스크린샷은 이용할 수 없습니다.`,
        question: '스마트폰이 없으면 QR 기획 승차권을 이용할 수 없나요?'
      },
      {
        answer: `【연령 구분】
・성인(12세 이상)
  성인 운임. 단, 13세 미만의 초등학생은 어린이 운임을 적용합니다.
・어린이(6세 이상 12세 미만)
  어린이 운임. 단, 6세로 초등학교 입학 전인 경우는 유아로 합니다.
`,
        question: '승차권의 연령 구분은?'
      },
      {
        answer: `대표자가 여러 명분을 함께 QR 기획 승차권을 구매하여 이용하시는 경우, 여러 장을 동시에 구매하신 경우에는 이용 시작 전에 각자의 스마트폰으로 SNS 등을 사용하여 분배를 부탁드립니다. 분배하지 않고 1대의 단말기로 여러 장의 승차권을 이용하는 경우, 평소보다 개찰기 통과 절차 시간이 더 걸려 이용하시는 열차에 탑승하지 못할 수 있으니 시간 여유를 가지고 이용해 주시기 바랍니다.
1대의 단말기로 여러 장의 QR 기획 승차권을 이용하여 자동 개찰기를 통과하는 경우, 반드시 바우처를 가진 고객이 마지막으로 통과하도록 해주십시오.
`,
        question: '승차권의 분배 기능이란?'
      },
      {
        answer:
          'QR 기획 승차권 이용일(승차일)에 「이용 시작」 버튼을 누른 경우, 그날의 막차까지 자동 개찰기를 이용하지 않으면 승차권이 무효가 됩니다. 반드시 승차하는 날의 첫차 시간 이후에 「이용 시작 버튼」을 눌러주십시오. 또한 자동 개찰기를 통과한 시점부터 디지털 티켓의 유효 기한이 시작됩니다.',
        question: '승차권 화면의 「이용 시작」이란?'
      },
      {
        answer:
          '일부 역에서는 QR 기획 승차권에 대응하는 자동 개찰기가 없는 개찰구가 있습니다. 개찰구의 역무원에게 문의해 주십시오. 승차 시 또는 하차 시에 역무 기기에서 처리가 필요합니다. 또한 역무원이 부재중인 개찰구는 인터폰 등으로 역무원을 호출해 주십시오. 역 사무소에서 거리가 있는 경우 역무원 도착까지 시간이 걸릴 수 있으니 시간 여유를 가지고 이용해 주시기 바랍니다.',
        question: 'QR 기획 승차권에 대응하는 개찰기가 없는 경우는?'
      },
      {
        answer: `유효 기간 내에서 이용 시작 전의 승차권에 한하여 판매 사이트에서 환불할 수 있습니다. (1회 결제당 환불 수수료 220엔)
여러 장의 QR 기획 승차권을 구매하여 환불하는 경우, 일부 승차권의 환불은 되지 않으며 모든 승차권이 환불되오니 주의해 주십시오.`,
        question: '환불할 수 있나요?'
      },
      {
        answer: `스마트폰 등의 정보 단말기를 분실하거나 배터리 방전 등으로 QR 기획 승차권의 화면 정보를 역 직원이 확인할 수 없는 경우, 유효한 승차권을 소지하지 않은 것으로 간주되어 실제로 승차한 구간의 정규 운임을 현금, IC 카드로 지불하셔야 합니다. 단말기의 충전 상태에 주의해 주십시오. 역에서 전원 등을 제공할 수 없으니 양해 부탁드립니다.`,
        question:
          '사용 중에 스마트폰이 고장 나거나 전원이 꺼진 경우에는 어떻게 해야 하나요?'
      },
      {
        answer: '유효한 승차권을 제시할 수 있으면 대체 수송 대상이 됩니다.',
        question: '대체 수송 대상이 되나요?'
      },
      {
        answer: `메일 문의 연락처로 연락해 주십시오.
메일 주소 helpcenter@linktivity.co.jp
`,
        question: '구매 후 확인 메일이 도착하지 않는 경우는?'
      },
      {
        answer:
          '구매 후나 이용 시작 후에 QR 기획 승차권을 이용할 수 없는 등의 문의 사항은 「예약 번호」「성함」을 명시하여 구매처로 연락 주시기 바랍니다.',
        question: 'QR 기획 승차권을 이용할 수 없는 경우는?'
      }
    ]
  },
  ticket: {
    buy: '구매',
    qrcode: {
      desc: 'QR 코드로 이용',
      title: '도쿄 메트로 24시간권'
    },
    ticketLink: {
      qrcode:
        'https://tokyometrods.triplabo.com/ko/product/prod_agptukhko553njmyzlfzyjd2ie?utm_source=tokyometro-digital-ticket.triplabo.jp&utm_medium=referral&utm_campaign=v3_migration&utm_content=tokyo_metro_24h_ticket_all_languages'
    }
  }
};
